import { useState } from "react";
import { Card, Container, FormButton, Text, Box } from "../components/UI"

import { useStripe, useElements, PaymentElement, CardElement } from '@stripe/react-stripe-js';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import { useUserData } from "../hooks/useUserData";
import { APP_SETTINGS } from "../hooks/useAppSettings";
import { useController } from "../hooks/useController";


export const RegisterStep3 = () => {
    const { handleSubmit, control, formState: { errors } } = useForm({ mode: 'onChange' });
    const [clientSecret, setClientSecret] = useState('');
    const { email, password, lang} = useUserData();
    const stripe = useStripe();
    const navigate = useNavigate();
    const elements = useElements();
    const {postData: send, data, error, isLoading} = useController();
    
    const registerUser = async (e) =>{
        e.preventDefault();
        await send( `${APP_SETTINGS.api}/Account/Register?email=${email}&password=${password}`, 'POST');
    }
    // main function
    const createSubscription = async (e) => {
        e.preventDefault();
        try {

            // create a payment method
            const paymentMethod = await stripe?.createPaymentMethod({
                type: "card",
                card: elements.getElement(CardElement),
                billing_details: {
                    email,
                },
            });

            // call the backend to create subscription
            const response = await fetch("http://localhost:3010/create-subscription", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    paymentMethod: paymentMethod?.paymentMethod?.id,
                    email

                }),
            }).then((res) => res.json());

            const confirmPayment = await stripe?.confirmCardPayment(
                response.clientSecret
            );

            if (confirmPayment?.error) {
                alert(confirmPayment.error.message);
            } else {
                alert("Success! Check your email for the invoice.");
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(()=>{

    },[isLoading])
    return (
        <Box display="columnCenter">
            <Container>
                <Card>
                    <Box display="rowStart">
                        <FontAwesomeIcon onClick={() => { navigate('/Register/Step2?email=' + email) }} icon={faArrowLeft} style={{ color: "white", cursor: "pointer", margin: 6 }} />
                        <Text>{lang?.step3of3}</Text>
                    </Box>
                    <Text role="h1">{lang?.chooseAPlan}</Text>
                    <Card role="subscription">
                        <Box display="columnCenter">
                            <Text role="h2">
                            {APP_SETTINGS.isFree ? 
                                <>
                                    {/* <span style={{textDecoration:'line-through'}}>{APP_SETTINGS.monthlySubscription} {APP_SETTINGS.currency}</span> <span>Free</span> */}
                                     <Text role="p">{lang?.noLineIsFree} </Text>
                                </>
                                :
                                
                                <>
                                {APP_SETTINGS.monthlySubscription} {APP_SETTINGS.currency}
                                <Text role="h3"> {APP_SETTINGS.frequency}</Text>
                                </>
                            }
                            </Text>
                            
                            
                           
                        </Box>
                        <Box display="columnStart">
                            <Box display="rowStart">
                                <FontAwesomeIcon icon={faCheckCircle} style={{ color: "white", width: 50 }} />
                                <Text>{lang?.noObligation}!</Text>
                            </Box>
                            <Box display="rowStart">
                                <FontAwesomeIcon icon={faCheckCircle} style={{ color: "white", width: 50 }} />
                                <Text>{lang?.useAsMuch}</Text>
                            </Box>

                            <Box display="rowStart">
                                <FontAwesomeIcon icon={faCheckCircle} style={{ color: "white", width: 50 }} />
                                <Text>{lang?.useYourDevices}!</Text>
                            </Box>
                        </Box>
                    </Card>
               
                        <form style={{backgroundColor:"white", borderRadius:10, padding:10}}>

                            {!APP_SETTINGS.isFree && <CardElement></CardElement>}
                            <br></br>
                            {APP_SETTINGS.isFree ? 
                               isLoading ?
                                <FormButton onClick={registerUser} role='primary' title="Subscribe">
                                    {lang?.pleaseWait}...
                                </FormButton>
                                :
                                <FormButton onClick={registerUser} role='primary' title="Subscribe">
                                    {lang?.register}
                                </FormButton>
                            :
                            <FormButton onClick={createSubscription} role="secondary" title="Subscribe">
                                {lang?.subscribe}
                            </FormButton>
                            }
                            {error && <span>{error.message}</span>}
                            {!error && error !== null && <span>{lang?.successRegister}</span>}
                        </form>
                
                </Card>
            </Container>
        </Box>
    )
}